module.exports = __webpack_public_path__ + "img/idCard2.3a05a029.png";